import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('Veranstaltung')

export default {
  label: 'Veranstaltung',
  route: 'veranstaltung',
  fields: [
    Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'),
    Filter.kumuliert(),
    Filter.Number('berichtsjahr', 'calendar-o'),
    Filter.ReferenceByMultiValueSearchRep('veranstalter', 'user', 'abstractPerson'),
    Filter.String('name'),
    Filter.String('veranstaltungsTyp'),
    Filter.String('stadt'),
    Filter.ReferenceBySearchRep('land'),
    {
      label: 'Veranstaltung.list.filter.virtuell',
      field: 'virtuell',
      type: 'select',
      translatable: true,
      values: [
        {
          value: 'TRUE',
          label: 'Veranstaltung.virtuell.TRUE'
        },
        {
          value: 'FALSE',
          label: 'Veranstaltung.virtuell.FALSE'
        },
        {
          value: null,
          label: ''
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/VeranstaltungFilter.js